import React from 'react';
import { SxStyle } from '../../../../types';
import Typography from '@mui/material/Typography';
import { BottomBarPreviewItem } from '../types';
import Box from '@mui/material/Box';
import AppMenuItemIcon from './app-menu-preview-item-icon';

const styles: SxStyle = {
  container: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    minWidth: '45px',
  },
  icon: {
    justifyContent: 'center',
    alignItems: 'center',
    display: 'inline-flex',
    width: '38px',
    height: '38px',
    padding: '8px',
  },
  text: {
    textTransform: 'uppercase',
    fontSize: '12px',
  },
};

interface Props {
  bottomBarItem: BottomBarPreviewItem;
  onClick?: () => void;
}

const AppMenuPreviewItem = ({ bottomBarItem, onClick }: Props) => {
  return (
    <Box sx={styles.container} onClick={onClick}>
      <AppMenuItemIcon icon={bottomBarItem.icon} />
      <Typography variant="body2-bold" sx={styles.text}>
        {bottomBarItem.text}
      </Typography>
    </Box>
  );
};

export default AppMenuPreviewItem;
